import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "9bb650e0-d289-4b43-8196-93c530c6af0c",
    content: "It is higher",
    options: {},
  },
  {
    id: "c9a93102-a9b9-43f7-9e59-9a47f3cfb0c8",
    content: "It is lower",
    options: {},
  },
  {
    id: "74745562-6009-4ec4-935a-d9ddf62cd415",
    content: "They are equal",
    options: {},
  },
];

export const task: Task = {
  id: "d0eaf986-3f6b-451d-adc4-8f05ec154c32",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    shuffle: true,
    columns: 3,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["9bb650e0-d289-4b43-8196-93c530c6af0c"],
};
